import { autoinject } from "aurelia-framework";
import { DialogSettings, DialogService } from "aurelia-dialog";
import { applicationLogger } from "../logging/logger";
import { DialogController } from 'aurelia-dialog';
import { LocationManagement } from "../controls/location-management";
import { IState}  from "../store/state";
import { IApplicationUser, ApplicationUser } from "../models/application-user";
import { Store } from "aurelia-store";
import { ApplicationClaimTypes } from "../models/application-claim-types";


@autoinject
export class SettingsDialog {
	dialogController: DialogController;
	locationManagement: LocationManagement;
	applicationUser: IApplicationUser;
	private subscription: any;

	constructor(private store: Store<IState>, dialogService: DialogController) {
    this.dialogController = dialogService;
	}

	canChangeLocations(): boolean {
		return this.applicationUser.hasAnyClaim(
			[ApplicationClaimTypes.administrateLocation, ApplicationClaimTypes.administrator]
		);
	}

	bind() {
		this.subscription = this.store.state.subscribe((state) => {
			var applicationUser = Object.assign({}, state.applicationUser);
			// NB: create an instance of ApplicationUser so we can call it's methods.
			this.applicationUser = new ApplicationUser(applicationUser as IApplicationUser);
		});
	}
	unbind() {
		this.subscription.unsubscribe();
	}

	async acceptChanges() {
		if (typeof this.locationManagement !== "undefined") {
			await this.locationManagement.acceptChangesAsync();
		}
		this.dialogController.ok();
	}
}